module.exports = __webpack_public_path__ + "img/menu_item1.83c96f4b.svg";